import { isDefined, isUndefined } from '../../../utils/isDefined';

const mapLicenses = licenses => {
  if (isUndefined(licenses)) {
    return {};
  }

  return {
    premiumAttendant: findLicense({ licenses, key: 'Premium_Attendant' }),
    chat: findLicense({ licenses, key: 'Chat' }),
    callControlApi: findLicense({ licenses, key: 'Call_control_API' }),
    cloudCtiApi: findLicense({ licenses, key: 'Cloud_CTI_API' }),
    lineStateApi: findLicense({ licenses, key: 'Line_state_API' }),
    crmConnect: findLicense({
      licenses,
      key: 'CRM_Connect_Organizational_Licence'
    }),
    thirdPartyCrmConnector: findLicense({
      licenses,
      key: '3rd_Party_CRM_Connector_Licence'
    }),
    teams: findLicense({
      licenses,
      key: 'Teams_and_PBX_Telephony_Connect_User_Add-on'
    }),
    webSoftphone: findLicense({
      licenses,
      key: 'ConnectMe_Telephony'
    }),
    callRecording: findLicense({
      licenses,
      key: 'UC_Analytics_Call_Recording_Organizational_Licence'
    })
  };
};

export default mapLicenses;

const findLicense = ({ licenses, key }) => {
  const founded = licenses.find(license => license.name === key);

  if (isUndefined(founded)) {
    return void 0;
  }

  if (
    key === 'ConnectMe_Telephony' ||
    key === 'UC_Analytics_Call_Recording_Organizational_Licence' ||
    key === 'Cloud_CTI_API'
  ) {
    if (isDefined(founded)) {
      return true;
    }
  }

  return isDefined(founded?.quota) && founded?.quota > 0 ? true : false;
};
